export enum AppQueryParamEnum {
    VIEW_TYPE = 'ds-viewtype',
}